import './RichTextEditor.scss';
import { sanitizeHTML } from './utils';

export interface IRichTextViewerProps {
  /**
   * HTML content to display (will be sanitized)
   */
  content?: string;
  /**
   * Additional CSS classes
   */
  className?: string;
  /**
   * Cypress data-cy attribute
   */
  dataCy?: string;
  /**
   * Test ID attribute
   */
  dataTestId?: string;
}

/**
 * RichTextViewer - Display rich text HTML content safely
 *
 * Companion component to RichTextEditor for displaying (not editing) rich text.
 * Sanitizes HTML content using DOMPurify before rendering.
 *
 * @example
 * ```tsx
 * <RichTextViewer
 *   content="<p><strong>Bold text</strong> and <em>italic</em></p>"
 * />
 * ```
 */
export const RichTextViewer = ({
  content = '',
  className = '',
  dataCy,
  dataTestId,
}: IRichTextViewerProps) => {
  const sanitizedContent = sanitizeHTML(content);

  return (
    <div
      className={`rich-text-viewer ql-editor ${className}`}
      data-cy={dataCy}
      data-testid={dataTestId}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
};
